import React from 'react'

function SvgUserX01Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M13.75 13.333l4.167 4.167m0-4.167L13.75 17.5M10 12.917H6.25c-1.163 0-1.745 0-2.218.143a3.333 3.333 0 00-2.222 2.222c-.143.473-.143 1.055-.143 2.218M12.083 6.25a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
      ></path>
    </svg>
  )
}

export default SvgUserX01Icon
